/**
 * Created by mzietek on 2016-11-19.
 */

(function () {
    'use strict';

    angular
        .module('repairforms.directive.module')
        .directive("includeReplace", IncludeReplace);

    function IncludeReplace() {
        return {
            require: 'ngInclude',
            link: function (scope, el, attrs) {
                el.replaceWith(el.children());
            }
        };
    }

})()